export * from "./lib/ngx-onlyoffice.component";
export * from "./lib/ngx-onlyoffice.module";
